import { useState } from "react";
import emailjs from "@emailjs/browser";

// Contact Section
export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSending(true);
    setStatusMessage("");

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      setStatusMessage("Message sent successfully.");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Email send failed:", error);
      setStatusMessage("Failed to send message. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section
      id="contact"
      className="py-24 lg:py-32 bg-[#091428]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="font-['Marcellus'] text-3xl sm:text-4xl text-[#F0E6D2] text-center mb-16 tracking-tight">
          Contact Me
        </h2>

        <div className="max-w-xl mx-auto">
          <div className="gold-frame p-8 relative bg-[#091428]">
            <div className="hextech-corner hextech-corner-tl" />
            <div className="hextech-corner hextech-corner-tr" />
            <div className="hextech-corner hextech-corner-bl" />
            <div className="hextech-corner hextech-corner-br" />

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="section-title block mb-2">Name</label>
                <input
                  type="text"
                  className="hextech-input"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                  data-testid="contact-name-input"
                />
              </div>
              <div>
                <label className="section-title block mb-2">Email</label>
                <input
                  type="email"
                  className="hextech-input"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  required
                  data-testid="contact-email-input"
                />
              </div>
              <div>
                <label className="section-title block mb-2">Message</label>
                <textarea
                  className="hextech-input min-h-[120px] resize-none"
                  placeholder="Your message..."
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  required
                  data-testid="contact-message-input"
                />
              </div>
              <button
                type="submit"
                className="btn-magic w-full"
                data-testid="contact-submit-btn"
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Send Message"}
              </button>

              {statusMessage && (
                <p className="text-sm text-[#A09B8C]">{statusMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
